module.exports = __webpack_public_path__ + "img/logo.03603d86.png";